import { effect } from '@preact/signals-react';
import type { SessionService } from 'src/services/SessionService';
import type { RootState } from 'src/store';
import type { ReactBindings } from 'src/types/bindings';

type WorkerAuthStore = Pick<ReactBindings['Store'], 'getState' | 'subscribeSelector'>;
type WorkerAuthSession = Pick<SessionService, 'accessToken'>;

export const installOptionsListWorkerAuthRelay = (
    store: WorkerAuthStore,
    sessionService: WorkerAuthSession,
    sendAuth: (auth: RootState['auth']) => void,
): Disposable => {
    const resources = new DisposableStack();
    const syncAuth = () => {
        const sessionAccessToken = sessionService.accessToken.value;
        const auth: RootState['auth'] = {
            ...store.getState().auth,
            accessToken: sessionAccessToken === null ? null : { token: sessionAccessToken },
        };
        sendAuth(auth);
    };

    resources.defer(store.subscribeSelector((state) => state.auth).handle(syncAuth));
    resources.defer(
        effect(() => {
            void sessionService.accessToken.value;
            syncAuth();
        }),
    );

    return resources;
};
